export default __webpack_public_path__ + "static/media/au-wa.3d2263e8.svg";